module.exports = __webpack_public_path__ + "media/images/lb/144-e7f5f3930b358177931cb5f95a2faa66.svg";